import { post } from '@alltrails/core/utils/post';
import { put } from '@alltrails/core/utils/put';
import Waypoint, { WaypointId } from '@alltrails/types/Waypoint';
import type { WaypointChangesResponse } from '../types/WaypointsApi';

export type UpdateWaypointPayload = {
  description: string;
  latitude: number;
  longitude: number;
  name: string;
  showTitle: boolean;
  waypointCategoryId?: NonNullable<Waypoint['waypointCategory']>['id'];
};

export function updateWaypoint(atMapId: number, waypointId: WaypointId, waypointChanges: UpdateWaypointPayload) {
  return put<WaypointChangesResponse>(`/api/alltrails/maps/${atMapId}/waypoints/${waypointId}`, waypointChanges);
}

export function reorderWaypoints(atMapId: number, orderedWaypointIds: WaypointId[]) {
  return post<WaypointChangesResponse>(`/api/alltrails/maps/${atMapId}/waypoints/reorder`, { ordered_waypoint_ids: orderedWaypointIds });
}

export function updateAllWaypoints(atMapId: number, toUpdate: Partial<Waypoint> & { showTitle?: boolean }) {
  return put<WaypointChangesResponse>(`/api/alltrails/maps/${atMapId}/waypoints/all`, toUpdate);
}
